import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fbSvg, instaSvg, xSvg } from "../Constants/Icons";
import { setFooterData } from "../Redux/UserSlice";
import ApiService from "../Service/ApiService";
const FooterRegisterPage = () => {
  const dispatch = useDispatch()
  const businessToken = useSelector(state => state?.userData?.business_token)
  const navigate = useNavigate();
  const data = useSelector((state) => state?.userData?.footerdata);
  const headerLogo = useSelector((state) => state?.userData?.header_logo);
  const headerName = useSelector((state) => state?.userData?.header_name);
  const[loading, setLoading] = useState(false)
  const [footerData, setFooterData] = useState({})
  const facebookurl = footerData?.facebook_url
  const twitterUrl = footerData?.twitter_url
  const linkedinUrl = footerData?.linkedin_url
  const instagramUrl = footerData?.insta_url


//   const getHomePageData = async () => {
//     try {
//         setLoading(true)
//         let data = await ApiService.request('get', 'getHomePageData', {
//             business_token: businessToken
//         })
//         if (data?.status) {
//           setFooterData(data?.data)
//            dispatch(setFooterData(data?.data))
//         } else {
//             // toast.error(data?.message)
//         }
//     } catch (error) {

//     } finally {
//         setLoading(false)
//     }
// }

// useEffect(() => {
//     if (businessToken) {
//         getHomePageData()
//     }
// }, [businessToken])
  return (
    <>
      {/* <footer
                id="fCol1"
                className="footer_row1 pt-md-2 pt-xl-4 position-relative bg-white"
            >
              
                <div className="position-absolute start-0 bottom-0 w-100 z-2 WavesWrapper">
                    <svg
                        className="waves"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        viewBox="0 24 150 28"
                        preserveAspectRatio="none"
                        shapeRendering="auto"
                    >
                        <defs>
                            <path
                                id="gentle-wave"
                                d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
                            />
                        </defs>
                        <g className="parallax">
                        
                            <use xlinkHref="#gentle-wave" x={48} y={0} fill="#E8E8E838" />
                            <use xlinkHref="#gentle-wave" x={48} y={3} fill="#E0E0E075" />
                            <use xlinkHref="#gentle-wave" x={48} y={5} fill="#E0E0E0" />
                         
                        </g>
                    </svg>
                </div>
            
                <div className="container footer_top py-4 py-xl-5 font-16px mt-xl-2 position-relative z-3 mb-xl-4">
                    <div className="d-flex justify-content-between align-items-md-center footertopRow flex-column flex-md-row">
                        <div>
                            <div className=" d-inline-flex footerLogo align-items-center align-items-md-start position-relative z-2 pe-1 flex-row flex-md-column">
                                {" "}
                                <img src={require("../assets/img/logo-white.png")} />
                                <span className="font-32px font-bold text-default pt-md-3 logoText">
                                    Law Society of Kenya
                                </span>
                            </div>
                        </div>
                        <div className="mb-2 mb-md-0">
                            <div className="wheather_wrap d-flex align-items-center justify-content-center">
                                <img src={require("../assets/img/wheather.png")} />
                            </div>
                        </div>
                        <div>
                            <div className="mb-3 mb-md-4 pb-md-2">
                                <div className="d-inline-flex align-items-center border-start border-primary border-3">
                                    <span className="mx-2 mx-xl-3">
                                        <svg
                                            className="fill-primary"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={31}
                                            height={31}
                                            viewBox="0 0 31 31"
                                            fill="none"
                                        >
                                            <circle cx="15.8408" cy="15.4805" r={15} />
                                            <path
                                                d="M19.7699 17.9675C19.6171 17.8247 19.4355 17.7115 19.2356 17.6342C19.0357 17.557 18.8213 17.5172 18.6049 17.5172C18.3884 17.5172 18.174 17.557 17.9741 17.6342C17.7742 17.7115 17.5926 17.8247 17.4398 17.9675L16.6449 18.7073C15.7498 18.1786 14.9205 17.5591 14.1723 16.8602C13.4213 16.1638 12.7557 15.3919 12.1876 14.5589L12.9826 13.819C13.1359 13.6768 13.2576 13.5078 13.3406 13.3217C13.4236 13.1356 13.4663 12.9362 13.4663 12.7347C13.4663 12.5332 13.4236 12.3337 13.3406 12.1476C13.2576 11.9616 13.1359 11.7926 12.9826 11.6504L11.431 10.2114C11.2804 10.0682 11.1004 9.9547 10.9016 9.87756C10.7029 9.80042 10.4896 9.76126 10.2742 9.76239C10.0574 9.76189 9.8426 9.80131 9.64219 9.87837C9.44178 9.95544 9.25972 10.0686 9.10648 10.2114L8.36087 10.9003C8.00548 11.2559 7.74024 11.6812 7.58464 12.1448C7.42904 12.6083 7.38705 13.0985 7.46174 13.5792C7.63718 15.4927 8.98587 17.794 11.0637 19.733C13.1416 21.672 15.6416 22.9221 17.6975 23.1058C17.8509 23.1135 18.0046 23.1135 18.158 23.1058C18.6006 23.1231 19.0424 23.058 19.4576 22.9143C19.8727 22.7706 20.2529 22.5512 20.5758 22.269L21.3159 21.575C21.4694 21.4324 21.591 21.263 21.6738 21.0764C21.7566 20.8899 21.7989 20.69 21.7984 20.4882C21.7996 20.2878 21.7575 20.0892 21.6746 19.9042C21.5918 19.7193 21.4698 19.5517 21.3159 19.4115L19.7699 17.9675ZM21.4969 10.0379C20.7349 9.3261 19.8292 8.76168 18.8317 8.37721C17.8343 7.99275 16.765 7.79585 15.6854 7.79787C15.54 7.79787 15.4006 7.85163 15.2978 7.94732C15.195 8.04301 15.1372 8.1728 15.1372 8.30813C15.1372 8.44346 15.195 8.57325 15.2978 8.66894C15.4006 8.76464 15.54 8.8184 15.6854 8.8184C16.6265 8.81837 17.5582 8.99179 18.4269 9.32865C19.2956 9.66552 20.084 10.1592 20.7466 10.7811C21.4092 11.403 21.9329 12.1409 22.2875 12.9522C22.6421 13.7635 22.8206 14.6321 22.8126 15.508C22.8126 15.6433 22.8704 15.7731 22.9732 15.8688C23.076 15.9645 23.2155 16.0182 23.3609 16.0182C23.5063 16.0182 23.6457 15.9645 23.7486 15.8688C23.8514 15.7731 23.9091 15.6433 23.9091 15.508C23.9196 14.4925 23.7116 13.4854 23.2973 12.5459C22.883 11.6065 22.2708 10.7537 21.4969 10.0379Z"
                                                fill="white"
                                            />
                                            <path
                                                d="M18.3771 12.9564C18.6882 13.2442 18.9344 13.587 19.101 13.9647C19.2677 14.3424 19.3515 14.7473 19.3475 15.1556C19.3475 15.2909 19.4053 15.4207 19.5081 15.5164C19.6109 15.6121 19.7503 15.6659 19.8957 15.6659C20.0411 15.6659 20.1806 15.6121 20.2834 15.5164C20.3862 15.4207 20.444 15.2909 20.444 15.1556C20.4512 14.6153 20.3432 14.0789 20.126 13.5778C19.9088 13.0766 19.5869 12.6206 19.1789 12.2361C18.7709 11.8516 18.2849 11.5463 17.7492 11.338C17.2135 11.1297 16.6386 11.0224 16.058 11.0225C15.9126 11.0225 15.7732 11.0762 15.6703 11.1719C15.5675 11.2676 15.5098 11.3974 15.5098 11.5327C15.5098 11.6681 15.5675 11.7978 15.6703 11.8935C15.7732 11.9892 15.9126 12.043 16.058 12.043C16.4901 12.046 16.9173 12.1282 17.3152 12.285C17.7131 12.4417 18.0739 12.6698 18.3771 12.9564Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </span>
                                    <div>
                                        <div>
                                            {" "}
                                            <a
                                                href="tel:+254 111 012200"
                                                className="font-22px font-bold link-default"
                                            >
                                                +254-799-595-800
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                <div className="d-inline-flex align-items-center border-start border-primary border-3">
                                    <span className="mx-2 mx-xl-3">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={31}
                                            height={31}
                                            viewBox="0 0 31 31"
                                            fill="none"
                                        >
                                            <circle cx="15.668" cy="15.3804" r={15} fill="#00226F" />
                                            <path
                                                d="M21.352 9.854H9.98349C9.60774 9.85551 9.2479 10.0122 8.98288 10.2897C8.71787 10.5671 8.56931 10.9428 8.5698 11.3342L8.5625 20.2159C8.56362 20.6081 8.7137 20.9839 8.97994 21.2613C9.24618 21.5386 9.60697 21.6949 9.98349 21.6961H21.352C21.7286 21.6949 22.0893 21.5386 22.3556 21.2613C22.6218 20.9839 22.7719 20.6081 22.773 20.2159V11.3342C22.7719 10.942 22.6218 10.5662 22.3556 10.2888C22.0893 10.0115 21.7286 9.85517 21.352 9.854ZM21.352 12.8144L15.6675 16.5148L9.98288 12.8144V11.3342L15.6675 15.0346L21.352 11.3342V12.8144Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </span>
                                    <div>
                                        <div>
                                            {" "}
                                            <a
                                                target="_blank"
                                                href="mailto:info@ksfchurch.com"
                                                className="font-22px font-bold link-default"
                                            >
                                                lsk@lsk.or.ke
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="py-3 py-md-4 text-center line-height-130 font-20px text-default position-relative z-3">
                    Powered by{" "}
                    <a
                        href="https://abngenesis.com/"
                        target="_blank"
                        className="font-20px link-default font-bold text-decoration-underline"
                    >
                        ABN Genesis{" "}
                    </a>{" "}
                    | A product of{" "}
                    <a
                        target="_blank"
                        href="https://www.abnosoftwares.com/"
                        className="font-20px link-default font-bold text-decoration-underline"
                    >
                        ABNO Softwares International Ltd
                    </a>
                    .
                </div>
            </footer> */}

      {/* <div className="">
        <footer className="custom-footer">
          <div className="footer-content">
            <div className="footer-logo">
              <img
                src={require("../assets/img/ft-logo-new.png")}
                alt="Kenya Association of Technical Training Institutions"
              />
              <p className="font-31px font-bold">
              Kenya Association 
                <br />
                <span>of Technical Training Institutions</span>
              </p>
            </div>
            <div className="social-icons">
              <a
                onClick={() => {
                  window.open(data?.facebook_url, "_blank");
                }}
              >
                <img src={fbSvg} alt="facebook-icon" />
              </a>
              <a
                onClick={() => {
                  window.open(data?.twitter_url, "_blank");
                }}
              >
                <img src={xSvg} alt="twitter-icon" />
              </a>
              <a
                onClick={() => {
                  window.open(data?.linkedin_url, "_blank");
                }}
              >
                <img
                  src={require("../assets/img/linkedin.png")}
                  style={{ width: 45 }}
                  alt="linkedin-icon"
                />
              </a>
              <a
                onClick={() => {
                  window.open(data?.insta_url, "_blank");
                }}
              >
                <img src={instaSvg} alt="instagram-icon" />
              </a>
            </div>
            <ul className="footer-nav">
              <li>
                <a
                  onClick={() => {
                    navigate("/educational-assistance-application");
                  }}
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    navigate("/search-advocate");
                  }}
                >
                  Members
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    navigate("/resources");
                  }}
                >
                  Resources
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    navigate("/home-contact");
                  }}
                >
                  Contact
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    navigate("/faq");
                  }}
                >
                  FAQ &amp; How-to Guides
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-bottom">
            <p className="font-16px font-regular text-white pt-25px">
              © {new Date().getFullYear()}, Kenya Association of Technical Training Institutions.
            </p>
          </div>
        </footer>
      </div> */}

          <footer id="" class="footer_row1   position-relative bg-white">
      
      
      
                      <div class="position-absolute start-0 bottom-0 w-100 z-2 WavesWrapper">
                          <svg
                              className="waves"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 24 150 28"
                              preserveAspectRatio="none"
                              shapeRendering="auto"
                          >
                              <defs>
                                  <path
                                      id="gentle-wave"
                                      d="M-160 44c30 0 58-18 88-18s58 18 88 18 58-18 88-18 58 18 88 18v44h-352z"
                                  />
                              </defs>
      
                              <g className="parallax">
                                  {/* <use href="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7)" />
                                  <use href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
                                  <use href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
                                  <use href="#gentle-wave" x="48" y="7" fill="#fff" /> */}
      
                                  {/* <use href="#gentle-wave" x="48" y="0" fill="#E8E8E838" />
                                  <use href="#gentle-wave" x="48" y="3" fill="#E0E0E075" />
                                  <use href="#gentle-wave" x="48" y="5" fill="#E0E0E0" /> */}
      <use href="#gentle-wave" x="48" y="3" fill="rgba(220, 233, 249, 0.7)" />
      <use href="#gentle-wave" x="48" y="5" fill="rgba(202, 225, 255, 0.5)" />
      <use href="#gentle-wave" x="48" y="5" fill="rgba(224,236,255,0.75)" />
      
                                  {/* <use href="#gentle-wave" x="48" y="7" fill="#f5edde" /> */}
                              </g>
                          </svg>
                      </div>
      
      
      
                      <div className="">
                      <footer className="custom-footer">
                          <div className=" footer-content z-3 position-relative">
                              <div className="footer-logo ft-logo">
                                  <img src={headerLogo} alt="" />
                                  {/* <p className="font-31px font-bold text-dark">
                                      Kenya Association
                                      <br />
                                      <span>of Technical Training Institutions</span>
                                  </p> */}
                              </div>
                              <div className="social-icons">
                                  <a href={facebookurl || "#"} target="_blank" rel="noopener noreferrer">
                                      <img src={fbSvg} alt="facebook-icon" />
                                  </a>
                                  <a href={twitterUrl || "#"} target="_blank" rel="noopener noreferrer">
                                     
                                 
                                      <img src={xSvg} alt="twitter-icon" />
                                  </a>
                                  <a href={linkedinUrl || "#"} target="_blank" rel="noopener noreferrer">
                                        
                                        <img
                                          src={require("../assets/img/linkedin.png")}
                                          style={{ width: 45 }}
                                          alt="linkedin-icon"
                                      />
                                  </a>
                                    <a href={instagramUrl || "#"} target="_blank" rel="noopener noreferrer">
                                      <img src={instaSvg} alt="instagram-icon" />
                                  </a>
                              </div>
                              {/* <ul className="footer-nav">
                                  <li>
                                      <a onClick={() => {
                                          navigate('/educational-assistance-application')
                                      }}>Services</a>
                                  </li>
                                  <li>
                                      <a onClick={() => {
                                          navigate('/search-advocate')
                                      }}>Members</a>
                                  </li> 
                                  <li>
                                      <a onClick={() => {
                                          navigate('/resources')
                                      }}>Resources</a>
                                  </li>
                                  <li>
                                      <a onClick={() => {
                                          navigate('/home-contact')
                                      }}>Contact</a>
                                  </li>
                                  <li>
                                      <a onClick={() => {
                                          navigate('/faq')
                                      }}>FAQ &amp; How-to Guides</a>
                                  </li>
                              </ul> */}
                          </div>
                          <div className="footer-bottom z-3">
                              <p className="font-16px font-regular text-dark pt-25px ps-3 pe-3 line-height-130">
                                  © {new Date().getFullYear()}, {headerName}. All rights reserved.
                              </p>
                          </div>
                      </footer>
                  </div>
      
                  </footer>
    </>
  );
};
export default FooterRegisterPage;
